module.exports = __webpack_public_path__ + "static/dashboard-2-4b7842a668b9077305c246450661fc36.png";